import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tree-navigation__search | filter__search"
}
const _hoisted_2 = { class: "tree-navigation__child-container" }
const _hoisted_3 = {
  key: 0,
  class: "tree-navigation__list"
}
const _hoisted_4 = {
  key: 0,
  class: "tree-navigation__child-count"
}

import {ref, computed, onMounted} from 'vue';
  import LeftNavigationCategoryTree from './LeftNavigationCategoryTree';
  import TextInput from '../../../bps/components/input/TextInput.vue';
  import {usePlaceholder} from '../../utilities/vueMixins/placeholderMixin/placeholder';

  const childLimit1 = 12;
  const childLimit2 = 25;

  
export default /*@__PURE__*/_defineComponent({
  __name: 'treeNavigation',
  props: {
    navigationTree: { default: null },
    navigationBranches: { default: null },
    level: { default: 1 },
    showNested: { type: Boolean, default: true }
  },
  setup(__props: any) {

  const props = __props;

  const structure = ref<LeftNavigationCategoryTree[]>(null);
  const isLastLevel = ref(false);
  const inputValue = ref('');
  const searchValue = computed(() => inputValue.value.trim());

  const filteredStructure = computed(() => {
    if (!searchValue.value) {
      return structure.value;
    }

    const regExp = new RegExp(searchValue.value, 'gi');
    return structure.value
      .filter(item => {
        return item.name.match(regExp);
      });
  });

  const parsedNavTree = props.navigationTree ? JSON.parse(props.navigationTree) : null;
  structure.value = parsedNavTree && parsedNavTree.children || props.navigationBranches;
  isLastLevel.value = true;
  for (let i = 0; i < structure.value.length; i++) {
    const item = structure.value[i];
    if (item.children.length > 0) {
      isLastLevel.value = false;
      break;
    }
  }

  onMounted(() => {
    usePlaceholder('tree-navigation');
  });

return (_ctx: any,_cache: any) => {
  const _component_tree_navigation = _resolveComponent("tree-navigation", true)!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'tree-navigation': true,
      'tree-navigation--long': structure.value.length > childLimit1,
      [`tree-navigation--level_${_ctx.level}`]: true,
      'tree-navigation--last-level': isLastLevel.value,
      'tree-navigation--hide-nested': !_ctx.showNested
    })
  }, [
    (structure.value.length > childLimit2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(TextInput, {
            ref: "input",
            label: _ctx.$t('productlist.filter.search'),
            name: "filter-search",
            autocomplete: "off",
            modelValue: inputValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
            "hide-label": "",
            "hide-mandatory-marker": ""
          }, null, 8 /* PROPS */, ["label", "modelValue"]),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "input__button input__button--icon_search" }, null, -1 /* HOISTED */))
        ]))
      : _createCommentVNode("v-if", true),
    _cache[4] || (_cache[4] = _createTextVNode()),
    _createElementVNode("div", _hoisted_2, [
      (filteredStructure.value.length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredStructure.value, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: _normalizeClass(["tree-navigation__item", {
            'tree-navigation__item--active': item.active,
            'tree-navigation__item--has-children': item.hasChildren,
            'tree-navigation__item--open': item.children.length,
          }])
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(item.linked ? 'a' : 'span'), {
                  href: item.linked ? item.link : null,
                  class: "tree-navigation__label"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name) + " ", 1 /* TEXT */),
                    (item.count !== null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, "\n              (" + _toDisplayString(item.count) + ")\n            ", 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["href"])),
                _cache[3] || (_cache[3] = _createTextVNode()),
                (item.children.length && _ctx.showNested)
                  ? (_openBlock(), _createBlock(_component_tree_navigation, {
                      key: 0,
                      "navigation-branches": item.children,
                      level: _ctx.level + 1
                    }, null, 8 /* PROPS */, ["navigation-branches", "level"]))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}
}

})